import { render, staticRenderFns } from "./ReadAloud.vue?vue&type=template&id=590ee548"
import script from "./ReadAloud.vue?vue&type=script&lang=js"
export * from "./ReadAloud.vue?vue&type=script&lang=js"
import style0 from "./ReadAloud.vue?vue&type=style&index=0&id=590ee548&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports